export default __webpack_public_path__ + "static/media/big4.3a68a4c5.jpg";